export default __webpack_public_path__ + "static/media/InVitro_Results_Server.8aed4445.png";